// extracted by mini-css-extract-plugin
export default {"radioGroup":"NotificationSettingsDialog-module__radioGroup__dDLxPCp","checkboxGroup":"NotificationSettingsDialog-module__checkboxGroup__WP_EKUX"};